import __var_0__ from './skewness.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Triangular distribution skewness.
*
* @module @stdlib/stats/base/dists/triangular/skewness
*
* @example
* var skewness = require( '@stdlib/stats/base/dists/triangular/skewness' );
*
* var v = skewness( 0.0, 1.0, 0.5 );
* // returns 0.0
*
* v = skewness( 4.0, 12.0, 5.0 );
* // returns ~0.532
*
* v = skewness( 2.0, 8.0, 7.0 );
* // returns ~-0.505
*/

// MODULES //
var skewness = __var_0__;


// EXPORTS //
export default skewness;
